import { ImgProps } from "assets/images/types";

export default function ImgBauducco(props: ImgProps) {
	const { height = 48, width = 156 } = props;
	return (
		<img
			src="/assets/images/companies/bauducco.webp"
			alt="Bauducco logo"
			loading="lazy"
			width={width}
			height={height}
		/>
	);
}
